import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function ActivityAssetsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('venue');

  const tabs = [
    { id: 'venue', label: '会场' },
    { id: 'play', label: '玩法' },
    { id: 'rights', label: '权益' },
    { id: 'delivery', label: '投放' },
    { id: 'redpack', label: '红包' },
    { id: 'coupon', label: '神券' }
  ];

  // 模拟数据
  const mockData = [
    {
      id: '1',
      name: '双十一主会场',
      resourceId: 'RES001',
      dataType: '会场配置',
      changeUser: '张三',
      changeTime: '2025-10-25 14:30:00'
    },
    {
      id: '2',
      name: '限时秒杀会场',
      resourceId: 'RES002',
      dataType: '会场配置',
      changeUser: '李四',
      changeTime: '2025-10-24 10:15:00'
    },
    {
      id: '3',
      name: '新人专享会场',
      resourceId: 'RES003',
      dataType: '会场配置',
      changeUser: '王五',
      changeTime: '2025-10-23 16:45:00'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="bg-gray-50 p-6">
        <div className="max-w-7xl mx-auto">
          {/* 页面标题 */}
          <div className="mb-6">
            <button
              onClick={() => navigate('/activities')}
              className="text-gray-600 hover:text-gray-900 mb-4 flex items-center"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              返回活动列表
            </button>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">活动资产清单</h1>
            <p className="text-gray-600">查看和管理活动的各类资源资产</p>
          </div>

          {/* Tab 导航 */}
          <Card className="mb-6">
            <div className="flex space-x-1 border-b border-gray-200">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`px-4 py-3 text-sm font-medium transition-colors border-b-2 ${
                    activeTab === tab.id
                      ? 'border-blue-600 text-blue-600'
                      : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* 表格 */}
            <div className="overflow-x-auto mt-6">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-50 border-b border-gray-200">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      资源名称
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      资源 ID
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      数据类型
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      变更人
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      变更时间
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      操作
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {mockData.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {item.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {item.resourceId}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {item.dataType}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {item.changeUser}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {item.changeTime}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <div className="flex space-x-2">
                          <button className="text-blue-600 hover:text-blue-800">
                            查看变更详情
                          </button>
                          <span className="text-gray-300">|</span>
                          <button className="text-blue-600 hover:text-blue-800">
                            查看资产关系图
                          </button>
                          <span className="text-gray-300">|</span>
                          <button className="text-blue-600 hover:text-blue-800">
                            拉群
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

